import React from 'react';

export type SVGatorAnimationProps = {
  source: {
    uri: string;
    width: number;
    height: number;
  };
  testID?: number | string;
  style?: object;
};

/**
 * SVGatorAnimation - this component embeds an SVG animated with the program SVGator.
 * It is necessary because these animations come bundled with embeded js in a CDATA tag
 * that will otherwise not work. https://www.svgator.com/help/getting-started/add-animated-svgs-to-react-website
 */
const SVGatorAnimation: React.FC<SVGatorAnimationProps> = ({
  source: { uri, width, height },
  testID,
  style,
}) => (
  <object
    data-testid={testID}
    style={style}
    className="chromatic-ignore"
    type="image/svg+xml"
    data={uri}
    width={width}
    height={height}
  >
    animation
  </object>
);

export default SVGatorAnimation;
